import * as Yup from 'yup'
import {
  INBOUND_TYPE,
  RESTOCK
} from 'domains/merchant-inbound/constants'
import TimeUtil from 'utils/time-util'

const idSchema = Yup.number()
  .positive('Required')
  .required()

const MerchantInboudCreateSchema = Yup.object().shape({
  merchant : Yup.object().required('Required'),
  quantity : Yup.number()
    .positive('Must be more than 0')
    .required('Required'),
  requested_date: Yup.date()
    .min(TimeUtil.yesterday(), 'Must today or future date')
    .required('Required'),
  is_restock: Yup.string()
    .oneOf(Object.values(RESTOCK),`Must be on of ${Object.values(RESTOCK).join(', ')}`)
    .required('Required'),
  inbound_type: Yup.string()
    .oneOf(Object.values(INBOUND_TYPE),`Must be on of ${Object.values(INBOUND_TYPE).join(', ')}`)
    .required('Required'),
  pickup: Yup.object().when('inbound_type', {
    is   : (value) => value === INBOUND_TYPE.PICKUP,
    then : Yup.object({
      street_address     : Yup.string().required('Required'),
      tl_province_id     : idSchema,
      tl_city_id         : idSchema,
      tl_district_id     : idSchema,
      tl_sub_district_id : idSchema,
      postal_code        : Yup.string()
        .required()
        .matches(/^\d{5}(?:[-\s]\d{4})?$/, 'Invalid postal code')
        .min(5, 'At least 5 digits')
    })
  })
})

export default MerchantInboudCreateSchema
